/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

import {
  Component, forwardRef, Input, Output, OnInit, EventEmitter, SimpleChanges, OnChanges,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SubjectViewModel } from '../share-panel';

@Component({
  selector: 'bulb-users-checklist',
  templateUrl: './users-checklist.component.html',
  styleUrls: ['./users-checklist.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UsersChecklistComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class UsersChecklistComponent implements OnInit, OnChanges {
  @Input() users: SubjectViewModel[];

  @Output() onChange = new EventEmitter();

  selectedUsers: SubjectViewModel[] = [];

  disabled: boolean = false;

  onTouched: any;

  ngOnInit(): void {
    this.selectedUsers = this.users;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.selectedUsers = changes.users.currentValue;
  }
}
